export default Object.freeze({

  YEAR: " year",
  MONTH: " month",
  MONTHS: " months",
  DAY: " day",
  HOUR: " hour",
  MINUTE: " minute",
  SELECT_REPORT_TYPE: "Please select at least one channel to generate the report.",

  /// ---------------------------- Menu Bar ---------------------------- 
  CHANNEL_1: "Channel 1",
  CHANNEL_2: "Channel 2",
  CHANNEL_3: "Channel 3",
  CHANNEL_4: "Channel 4",

  LIVE_LIST: "Live List",
  LIVE_LIST_MATRIX: "Matrix",
  OSCILLOSCOPE: "Oscilloscope",
  BAR_GRAPH: "Bar graph",
  DADOS: "Variable Status",
  DADOS_MENU: "Data",
  INFORMATION: "Information",
  LIMIT: "Limit",
  STATUS_INFORMATION: "Status Information",
  STATUS_DADOS: "Status",
  VALOR: "Value",
  LOG: "Log",
  REPORT: "Report",
  CONFIG: "Settings",

  PORTUGUESE: "Portuguese",
  ENGLISH: "English",
  SPANISH: "Spanish",

  UPDATING_LANGUAGE_WAITING: "Changing language, please wait a moment",
  UNABLE_TO_ALTER_LANGUAGE: "Could not change the program language.\n",

  // ------------------------------ Data ------------------------------

  DADOS_INPUT_TEXT_PLACEHOLDER: "Filter by address or limit",
  // ---------------------------- Live List ----------------------------
  GOOD_STRING: "Good",
  ATTENTION_STRING: "Attention",
  BAD_STRING: "Bad",
  FAULT_STRING: "No signal",
  UNKNOWN_STRING: "Unknown",

  LIVE_LIST_INPUT_TEXT_PLACEHOLDER: "Filter by address or signal",

  REMOVE_POSITIONING: "Delete failed device",
  REMOVE_DEVICE_MODAL_CONTENT_1: "Are you sure you want to delete the device?",
  REMOVE_DEVICE_SUCCESS: "The device will be removed on the next scan.",
  REMOVE_DEVICE_FAILURE: "An error occurred while removing the device: ",
  LIVE_LIST_DEVICE_FAULT_POPUP_TEXT_2: "By clicking the cell, you can delete the device if desired.",
  ADDRESS: "Address",
  AMPLITUDE: "Amplitude",
  UNBALANCE: "Unbalance",
  MIN_AMPLITUDE: "Minimum amplitude",
  MAX_AMPLITUDE: "Maximum amplitude",
  DEVIATION: "Deviation",
  NOISE: "Noise",
  I_FAULTS: "Faults",
  STATUS: "Signal",
  SIGNAL: "Signal",
  JITTER: "Jitter",
  FAULT_PERCENT: "Fault %",
  COMMUNICATION: "Communication",
  FAULT: "Fault",
  DATA_EXCHANGE_1: "Data",
  DATA_EXCHANGE_2: "exchange",
  DATA_EXCHANGE: "Data exchange",
  DATA_EXCHANGE_LINE1: "Data\n",
  DATA_EXCHANGE_LINE2: "\n",
  DATA_EXCHANGE_LINE3: "exchange",

  PORCENTAGEM: "%",
  MILLIVOLT: "mV",
  VOLTAGE: " V",
  VOLTAGE_PEAK_TO_PEAK: " V",
  A: "A",
  B: "B",
  CHANNEL_A_PROBLEM: "Problem indication on channel A",
  CHANNEL_B_PROBLEM: "Problem indication on channel B",
  MASTERS: "Master",
  SLAVES: "Slaves",
  BAUD_RATE_KBPS: "BAUD RATE (Kbps)",
  BAUD_RATE_MBPS: "BAUD RATE (Mbps)",
  CURRENT_CHANNEL: "Current channel",
  CHANNEL_TAG_STR: "Channel tag",

  NETWORK_DATA: "Network data",

  MODAL_TITLE: "Characteristic waveforms",

  TURNED_ON: "On",
  TURNED_OFF: "Off",

  ANALYSIS_ERROR: "An error occurred while changing the analysis state",

  ANALYSIS: "Analysis",
  ANALYZER: "Analyzer",

  DETECTED_PROBLEMS: "Detected problems:",
  INIT_PICO_NOT_FOUND: "TS Scope PA encountered an internal error that prevented it from working correctly. Please restart TS Scope PA. If the problem persists, contact Toledo & Souza for support.",
  INVERTED_POLARITY: "There are devices on the network with inverted polarity.",
  MONGO_OFF: "TS Scope PA detected an error in its internal database. Please restart TS Scope PA. If the problem persists, contact Toledo & Souza for support.",
  PICO_NOT_FOUND: "TS Scope PA encountered an internal error that prevented it from working correctly. Please restart TS Scope PA. If the problem persists, contact Toledo & Souza for support.",
  MONGO_REPAIR_SUCCESS: "Error repaired successfully! Please close the program and open it again for the changes to take effect.",
  MONGO_REPAIR_ERROR: "Could not solve the problem. Please contact support.",
  SCAN_FAIL_FOUND: "TS Scope PA lost connection to the PROFIBUS PA network. Make sure it is correctly connected to the network. After connecting it, please restart TS Scope PA.",

  REPAIR: "Repair",
  LOADING_ANALYZER: "Starting analyzer, please wait.",

  A_DEVICES: "A Devices",
  B_DEVICES: "B Devices",

  AMPLITUDE_POPUP_STR1: "Shows the current, minimum, and maximum signal amplitude of each PA device on the network.",
  AMPLITUDE_POPUP_STR2: "The minimum value is 3 Vpp and the maximum is 8 Vpp.",
  SIGNAL_POPUP_STR: "Indicates that the amplitude is outside the standard.",
  I_FAULTS_POPUP_STR: "Slave with a data exchange problem.",
  NOISE_POPUP_STR: "<b>Noise</b> is calculated during the <b><i>idle</i></b> time of each device on the network and must not exceed <b>100 mV</b>. These values are practical references.",
  DEV_POPUP_STR1: "Indicates the signal deviation value in relation to the frequency oscillator, that is, the timing relationship between where the signal should cross zero and where it actually crosses.",
  DEV_POPUP_STR2: "It may indicate capacitive coupling to the bus or a hardware problem.",
  DEV_POPUP_STR3: "The limits are -0.8 us to +1.6 us.",

  DATA_EXCHANGE_POPUP_STR_1: "Indicates that the slave is exchanging data with the Master.",
  DATA_EXCHANGE_POPUP_STR_2: "Indicates that the slave stopped exchanging data with the Master.",

  FAULT_POPUP_STR_1: "No problems occurred during data exchanges.",
  FAULT_POPUP_STR_2: "Indicates that at some point during the analysis a retry occurred.",
  FAULT_POPUP_STR_3: "Indicates that at some point during the analysis the slave stopped exchanging data with the Master.",
  FAULT_POPUP_STR_4: "TS Scope PA reads data in blocks, not by streaming. Because of this, retries that occur outside the reading window will not be detected by the analyzer.",
  PS: "NOTE:",

  ANALYSIS_INIT_ERROR: "An error occurred while starting the analysis. Please try starting it again.",
  LOADING_HOMEPAGE_2: "This process may take a few minutes.",
  CANCEL: "Cancel",

  NO_ACTIVE_NETWORK: "TS Scope PA did not find an active network. Make sure it is correctly connected to a PROFIBUS PA network. After connecting it, please restart TS Scope PA.",
  INVALID_SERIAL: "The serial number does not correspond to this TS Scope PA. Please reinstall the program with a valid serial number.",

  CLEANING_BUFFER: "Cleaning buffer...",
  SEPARATING_WAVES: "Analyzing data...",
  VERIFYING_NETWORK_TYPE: "Checking network...",
  FINDING_SLAVES: "Finding slaves...",

  TIME_ON: "Time on:",

  SIGNAL_QUALITY: "Signal quality",
  SIGNAL_QUALITY_DESCRIPTION_1: "In the 'Signal' column, the worst case is always considered for average and minimum amplitude.",

  GOOD: "Good",
  GOOD_DESCRIPTION_1: "• Minimum amplitude between 550 and 1100 mV",
  GOOD_DESCRIPTION_2: ". Slaves communicating normally; the standard indicates between 750 mV",
  GOOD_DESCRIPTION_3: " and 1 V",

  ATTENTION: "Attention - Preventive action",
  ATTENTION_DESCRIPTION_1: "• Minimum amplitude between 350 and 550 mV",
  ATTENTION_DESCRIPTION_2: "• Minimum amplitude between 1100 and 1400 mV",

  BAD: "Bad - Corrective action",

  BAD_DESCRIPTION_1: "• Minimum amplitude less than 350 mV",
  BAD_DESCRIPTION_2: ". It may be caused by too many terminators, a very long bus, humidity, etc.",
  BAD_DESCRIPTION_3: "• Minimum amplitude greater than 1400 mV",
  BAD_DESCRIPTION_4: ". It may be caused by missing terminators, equipment problems, etc.",

  LIGHT_TONES: "Light tones",
  LIGHT_TONES_DESCRIPTION: "• TS Scope PA is not finding a response from the slave, so the software keeps the measurements from the last capture and uses a light tone to indicate that the data is not being updated.",

  NOISE_DESCRIPTION_1: "The ",
  NOISE_DESCRIPTION_2: "Noise",
  NOISE_DESCRIPTION_3: " is calculated during the ",
  NOISE_DESCRIPTION_4: "idle",
  NOISE_DESCRIPTION_5: " time of each device on the network and must not exceed ",
  NOISE_DESCRIPTION_6: "These values are practical references.",

  JITTER_DESCRIPTION_1: "The ",
  JITTER_DESCRIPTION_2: "Jitter",
  JITTER_DESCRIPTION_3: " is the signal displacement in time relative to the ideal zero crossing.",
  JITTER_DESCRIPTION_4: "If it occurs, it may prevent the PROFIBUS PA equipment electronics from reading the message.",
  JITTER_DESCRIPTION_5: "Its value defined by the standard must be less than ",
  JITTER_DESCRIPTION_6: ", which is equivalent to ",

  UNBALANCE_DESCRIPTION_1: "The ",
  UNBALANCE_DESCRIPTION_2: "unbalance",
  UNBALANCE_DESCRIPTION_3: " is the measurement of the signal displacement relative to AC zero, that is, whether the signal is shifted upward or downward. ",
  UNBALANCE_DESCRIPTION_4: "This measurement is made from the difference between the averages of the negative and positive parts of the signal. ",
  UNBALANCE_DESCRIPTION_5: "It generally indicates a problem in the equipment electronics, mainly a possible failure in the PROFIBUS PA power/signal isolation.",
  
  // ---------------------------- Oscilloscope ----------------------------
  GRAPH: "Graph",
  A_AND_B: "A and B",
  B_A: "B - A",
  WAVE_FORM: "Waveform",
  AMPLITUDE_A: "Amplitude A",
  AMPLITUDE_B: "Amplitude B",
  ADDRESS_DP: "Address: ",
  CHANNEL_DP: "Channel: ",
  WAVE_A: "Signal A",
  WAVE_B: "Signal B",
  WAVE_PA: "PA Signal",

  NANOSSECOND: "ns",
  MICROSSECOND: " µs",
  MILLISSECOND: " ms",
  SECOND: "s",

  TIME_NS: "Time (ns)",
  TIME_US: "Time (μs)",
  TIME_MS: "Time (ms)",
  TIME_S: "Time (s)",

  AMPLITUDE_PLACEHOLDER: "0.0 mV",
  TIME_INTERVAL_PLACEHOLDER: "0.0 ",
  CURSORS: "Cursors",
  CONTROLS: "Controls ",
  TIME_INTERVAL: " time",
  CONTROLS_POPUP_TEXT: "After pressing PLAY, the waveform is updated every 2 seconds.",
  CONTROLS_POPUP_TEXT_2: "To enable the controls, you must select manual view and choose a device.",

  VISUALIZATION: "View",
  AUTOMATIC: "Automatic",
  MANUAL: "Manual",

  KBPS: "Kbps",

  PS_1: "Note 1:",
  PS_2: "Note 2:",
  PS_3: "Note 3:",

  TIME: "Time: ",

  MASTER_SUFFIX: " - Master",
  MASTER_PREFIX: "Master - ",

  STD_WAVE_FORM: "Standard waveform",
  EXCESS_TERMINATIOR_WAVE_FORM: "Typical waveform with too many terminators",
  FEW_TERMINATOR_WAVE_FORM: "Typical waveform with too few terminators",
  FOR_MORE_INFO: "For additional information, consult Toledo & Souza or the PROFIBUS International guidelines. It is worth noting that the events shown may occur together, which changes the patterns shown.",

  // ---------------------------- Bar Graph ----------------------------
  ORDER_BY: "Sort by",
  AMPLITUDE_ASC: "Ascending amplitude",
  AMPLITUDE_DESC: "Descending amplitude",
  ADDRESS_ASC: "Ascending address",
  VOLTAGE_V: "Voltage (V)",
  VOLTAGE_MV: "Voltage (mV)",
  UNBALANCE_PORCENT: "Unbalance Rate (%)",
  VOLTAGE_V_PEAK_TO_PEAK: "Voltage (V)",
  ORDER: "Sorting",
  REFRESH_DATA: "Refresh data",
  LOADING: "Loading",
  BAR_GRAPH_TYPE_PLACEHOLDER: "Select a bar graph type",
  ACTUAL: "Current",
  VARIATION: "Variation",
  CURRENT: "Current",
  MICROSSECOND_TITLE: "Microseconds (µs)",

  NOISE_PA: "Noise: ",
  NOISE_MIN: "Minimum Noise",
  NOISE_MAX: "Maximum Noise",
  NOISE_ASC: "Ascending noise",
  NOISE_DESC: "Descending noise",

  JITTER_PA: "Jitter: ",
  JITTER_MIN: "Minimum Jitter",
  JITTER_MAX: "Maximum Jitter",
  JITTER_ASC: "Ascending jitter",
  JITTER_DESC: "Descending jitter",

  UNBALANCE_PA: "Unbalance: ",
  UNBALANCE_ASC: "Ascending unbalance",
  UNBALANCE_DESC: "Descending unbalance",

  MINIMUM_MASC: "Minimum",
  MINIMUM_FEM: "Minimum",
  MAXIMUM_MASC: "Maximum",
  MAXIMUM_FEM: "Maximum",

  COMPLETE: "Complete",
  DETAILED: "Detailed",

  MODE_POPUP_TEXT_1: "Detailed mode shows the initial part of the complete captured waveform, as if zooming in on the beginning of the wave.",
  MODE_POPUP_TEXT_2: "Complete mode shows the entire waveform.",

  JITTER_MESSAGE_HEADER: "Jitter Value Interpretation",
  JITTER_MESSAGE_1: "The jitter value corresponds to the absolute value recorded by TS Scope PA. Absolute value represents only the magnitude of a number, regardless of its sign (positive or negative). In other words, it indicates the distance of the number from zero.",
  JITTER_MESSAGE_2: "If the minimum recorded jitter value is -4 µs, the displayed value will be 4 µs.",
  EXAMPLE: "Example",
  
  // ---------------------------- Log ----------------------------
  INSERT_VALID_ADDRESS_OR_TYPE: "Please enter a valid event type.",
  BEFORE_MONITOR_INIT_STR: "Before the last initialization",
  LOG_INPUT_TEXT_PLACEHOLDER: "Filter by address or event type",
  LOG_WAITING: "Loading log data",
  HORARY: "Time",
  DESCRIPTION: "Description",
  TYPE: "Type",

  PA_TERMINATION_OFF_LOG_DESCRIPTION: "TS Expert detected a missing termination condition.",
  PA_CAPACITIVE_EFFECT_LOG_DESCRIPTION: "TS Expert detected an out-of-specification jitter condition.",
  PA_NOISE_LOG_DESCRIPTION: "TS Expert detected a possible noise condition on the PA network.",
  PA_INVERTED_POLARITY_LOG_DESCRIPTION: "TS Expert detected a possible polarity inversion condition.",
  PA_HIGH_RESISTANCE_LOG_DESCRIPTION: "TS Scope PA detected an attenuated signal condition.",
  PA_DADOS_LOG_DESCRIPTION: "TS Scope PA detected an anomaly in the variable status ",
  PA_UNBALANCE_LOG_DESCRIPTION: "TS Scope PA detected an unbalance condition.",
  EVENT_CHECKED_SUCCESS: "The event was cleared successfully.",

  // ---------------------------- Report ----------------------------
  REPORT_EXPORT_NAME: "TS Scope PA Report",

  HEADER_TEXT: "TS Scope PA",
  GENERATE_REPORT: "Generate report",

  SELECT_CLIENT: "Saved clients",
  SELECT_EXECUTOR: "Saved executing companies",
  CLIENT_NOT_FOUND: "No saved clients with that name",
  EXECUTOR_NOT_FOUND: "No saved executing companies with that name",

  GENERAL_REPORT: "General report - TS Scope PA",
  DATA_REPORT: "Data report - TS Scope PA",

  CLIENT_INFO: "Client information",
  EXECUTING_COMPANY_INFO: "Executing company information",
  CONFORMITY: "Conformity",
  ANNOTATIONS: "Notes",
  CONCLUSION: "Conclusion",

  DROPDOWN_PLACEHOLDER: "Choose an option",
  CONFORM: "Compliant",
  CONFORM_W_RESTRICTION: "Compliant with restrictions",
  NON_CONFORM: "Non-compliant",

  PROJECT_NAME: "- Project name:",
  NETWORK_NAME: "- Network name:",
  LOCATION: "- Location:",
  COMPANY_NAME: "- Company name:",
  ACCOUNTABLE_NAME: "- Responsible person:",
  COMPANY_ADDRESS: "- Address:",
  COMPANY_CITY: "- City:",
  COMPANY_TEL: "- Phone:",

  EXECUTING_COMPANY_NAME: "- Company name:",
  EXECUTING_ACCOUNTABLE_NAME: "- Responsible person:",
  EXECUTING_TEL: "- Phone:",
  EXECUTING_EMAIL: "- Email:",

  ETHERNET_INFO: "ETHERNET information",

  IP_DP: "- IP: ",
  MASK_DP: "- Mask: ",
  GATEWAY_DP: "- Gateway: ",

  NETWORK_NAME_DP: "- Network name: ",

  SUMMARY: "Summary",
  CHANNEL: "Channel",
  VALOR_DADOS: "Value",
  VARIEAVEL_DADOS: "Variable",
  LIVE_LIST_PAGE_TITLE: "1 - Live List",
  OSCILLOSCOPE_PAGE_TITLE: "2 - Oscilloscope",
  BAR_GRAPH_PAGE_TITLE: "3 - Bar graph",
  DADOS_PAGE_REPORT_TITLE: "4 - Data",
  LOG_PAGE_TITLE: "5. - Event log",

  LAST_200_EVENTS: "Last 200 events",

  PROTOCOL: "- Protocol:",
  PROTOCOL_TYPE: "PROFIBUS PA",

  ANALYZER_VERSION_STRING: "- TS Scope PA version:",
  ANALYSIS_INIT: "- Analysis start time:",

  ANALYSIS_INFO: "Analysis information",
  GENERATED_BY: "- Generated by TS Scope PA",
  HARDWARE_VERSION: "- Hardware version:",
  SOFTWARE_VERSION: "- Software version:",
  DATE_TIME: "- Date and time:",
  BAUD_RATE: "- Baud rate:",
  NUM_MASTERS: "- Master:",
  NUM_SLAVES: "- Slaves:",

  LIVE_LIST_DOTS: ".....................................................................................................................................",
  BAR_DOTS: "......................................................................................................................",
  OSC_DOTS: ".............................................................................................................................",
  LOG_DOTS: ".............................................................................................................................................",
  DADOS_DOTS: ".........................................................................................................................................",
  DISCLAIMER_DOTS: ".................................................................................................................................",

  GENERATING_REPORT_WAITING: "Generating report, please wait",
  GENERATING_REPORT_SUCCESS: "Report generated successfully. To save it, click save report below.",

  MASTER_PA: "Master: ",
  SLAVE_PA: "Slave: ",
  SIGNAL_PA: "Signal: ",
  AMPLITUDE_PA: "Amplitude: ",
  AMPLITUDE_MIN_PA: "Minimum amplitude: ",
  AMPLITUDE_MAX_FF: "Maximum amplitude: ",
  DEVIATION_DP: "Deviation: ",
  I_FAULTS_DP: "Faults: ",
  PERCENT_FAULTS_DP: "Faults %: ",

  OVERSHOOTING_DP: "Overshoot: ",

  END_OF_REPORT: "End of report",
  DISCLAIMER: "Legal notice",
  DISCLAIMER_TEXT: "The data and values presented in this report are merely auxiliary for the PA specialist, so any indication of correction must be made by the user. For this reason, monitoring by a specialist engineer or technician responsible for the analysis is recommended to certify the information provided by the product. Therefore, Toledo & Souza is exempt from any liability, losses, or damages, direct or indirect, caused by interpretations of the software, and offers no warranty regarding the integrity, quality, or suitability of the information provided, as it depends on the technical analysis of a qualified professional. In the absence of such a professional, the user assumes the risk that the content may be inaccurate, incomplete, or may not meet their needs and requirements.",

  // ---------------------------- Manage Information ----------------------------
  SAVE: "Save",
  REMOVE: "Remove",

  CHOOSE_CLIENT_ID: "You must choose an identifier for the client.",
  CLIENT_ID_ALREADY_EXISTS: "A client with this identifier already exists.",
  SAVE_CLIENT_SUCCESS: "Client saved successfully!",
  SAVE_CLIENT_ERROR: "An error occurred while saving the client information.",

  CHOOSE_EXECUTING_COMPANY_ID: "You must choose an identifier for the executing company.",
  EXECUTING_ID_ALREADY_EXISTS: "An executing company with this identifier already exists.",
  SAVE_EXECUTING_COMPANY_SUCCESS: "Executing company saved successfully!",
  SAVE_EXECUTING_COMPANY_ERROR: "An error occurred while saving the executing company information.",

  CHOOSE_CLIENT_FIRST: "You must choose a client first.",
  CHOOSE_EXECUTING_COMPANY_FIRST: "You must choose an executing company first.",

  ALTER_CLIENT_SUCCESS: "Client information changed successfully.",
  ALTER_CLIENT_ERROR: "An error occurred while changing the client information.",

  ALTER_EXECUTING_COMPANY_SUCCESS: "Executing company information changed successfully.",
  ALTER_EXECUTING_COMPANY_ERROR: "An error occurred while changing the executing company information.",

  REMOVE_CLIENT: "Remove client",
  REMOVE_EXECUTING_COMPANY: "Remove executing company",

  REMOVE_CLIENT_SUCCESS: "Client information removed successfully.",
  REMOVE_CLIENT_ERROR: "An error occurred while removing the client information. Check whether it is still saved.",

  REMOVE_EXECUTING_COMPANY_SUCCESS: "Executing company information removed successfully.",
  REMOVE_EXECUTING_COMPANY_ERROR: "An error occurred while removing the executing company information. Check whether it is still saved.",

  CONFIRM_REMOVE_CLIENT_TEXT: "Are you sure you want to remove this client?",
  CONFIRM_REMOVE_EXECUTING_COPANY_TEXT: "Are you sure you want to remove this executing company?",

  YES: "Yes",
  NO: "No",

  // ---------------------------- Configuration page related ----------------------------
  USERNAME: "User",
  NEW_PWD: "New password",
  REPEAT_PWD: "Repeat password",
  TAG_PA: "TS Scope PA tag",
  TAG_CHANNELS: "Test network",

  TS_SCOPE_PA_REPORT_CHANNEL: "TS Scope PA Report - Channel",
  REPORTS_TS_SCOPE_PA: "Reports - TS Scope PA.zip",

  PROJECT_NAME_: "Project name",
  NETWORK_NAME_: "Network name",
  LOCATION_: "Location",
  COMPANY_NAME_: "Company name",
  RESPONSIBLE_NAME: "Responsible person",
  ADDRESS_: "Address",
  CITY: "City",
  TEL: "Phone",
  CLIENT_LOGO: "Client logo",
  EMAIL: "Email",
  EXECUTING_COMPANY_LOGO: "Executing company logo",
  CHANNELS_INCLUDED_REPORT: "Channels included in the report",

  LOGIN: "LOGIN",
  ENTER: "Enter",
  LOGOUT: "Logout",
  RESTART_SYSTEM: "Restart System",
  IP: "IP",
  MASK: "Mask",
  GATEWAY: "Gateway",
  TAG: "Tag",
  TAGS: "Tags",
  SETUP: "Configure",
  EDIT: "Edit",
  SOFTWARE_UPDATE: "Software Update",
  INTERFACE_CONFIG: "Interface Settings",
  CURRENT_VERSION: "Current version: ",
  UPDATE: "Update",
  ALTER_LOGIN: "Change login",
  ARE_YOU_SURE_ALTER_CONFIG: "Are you sure you want to change the TS Scope PA settings?",
  INVALID_OR_CORRUPT_FILE: "The file is not valid or is corrupted.",
  IMPORT: "Import",
  EXPORT: "Export",
  LOGIN_CREDENTIALS_FAILURE: "An error occurred while logging in: incorrect username or password.",
  LOGIN_GENERAL_FALIURE: "An error occurred while logging in:",

  GPG_ALERT_MESSAGE: "Only files with the .gpg extension can be sent",
  GPG_FILE_EXTENSION: ".gpg",
  SEND_FILE_SUCCESS: "The file was sent successfully.",
  SEND_FILE_SUCCESS_WARNING: "Remember to check whether your computer's network card is on the same subnet as IP: ",
  SEND_FILE_FAILURE: "An error occurred while sending the file.",
  SEND_FILES_SUCCESS: "The files were sent successfully.",
  SEND_FILES_FAILURE: "An error occurred while sending the files.",
  SEND_FILE_WAITING: "Sending the file.",
  SEND_FILE_WRONG_FILENAME: "Invalid name. The update file must be named: updateSPA.tar.gz.gpg",
  SEND_FILE_CORRUPTED_FILE: "The update file was corrupted during upload.",
  SEND_CONFIG_SUCCESS: "The settings were sent successfully.",
  SEND_CONFIG_FAILURE: "An error occurred while sending the settings.",
  SEND_CONFIG_WAITING: "Sending the settings.",
  SEND_CONFIG_WAITING_2: "Finishing settings upload.",
  SEND_CONFIG_DONE: "Settings sent.",
  START_MESSAGE_SUCCESS: "TS Scope PA will start in 15 seconds.",
  START_MESSAGE_FAILURE: "An error occurred while starting TS Scope PA.",
  STOP_MESSAGE_SUCCESS: "TS Scope PA will stop in 15 seconds.",
  STOP_MESSAGE_FAILURE: "An error occurred while stopping TS Scope PA.",
  WAITING: "Please wait a moment",
  CLEAN_LOG_SUCCESS_1: "The log for 'Channel ",
  CLEAN_LOG_SUCCESS_2: "' was cleared successfully.",
  CLEAN_LOG_FAILURE: "An error occurred while clearing the log.",
  CLEAR: "Clear",
  CLEAN_STATISTICS_SUCCESS: "The statistics were cleared successfully.",
  CLEAN_STATISTICS_FAILURE: "An error occurred while clearing the statistics.",
  RESET_TRAFFIC_SUCCESS: "The values will be reset on the next scan.",
  RESET_TRAFFIC_FAILURE: "An error occurred while resetting the error increments.",
  RESET_DEVICES_SUCCESS: "The device data was cleared successfully.",
  RESET_DEVICES_FAILURE: "An error occurred while clearing the device data.",
  CHANGE_USERNAME_SUCCESS: "The username was changed successfully. Please log in again.",
  CHANGE_USERNAME_FAILURE: "An error occurred while changing the username: ",
  USERNAME_TOO_SHORT: "The username must contain at least one character.",
  PASSWORD_MISSMATCH: "The entered passwords do not match",
  CHANGE_PASSWORD_SUCCESS: "The password was changed successfully. Please log in again.",
  CHANGE_PASSWORD_FAILURE: "An error occurred while changing the password: ",
  RESET_RETRIES_SUCCESS: "The retries were cleared successfully.",
  RESET_RETRIES_FAILURE: "An error occurred while clearing the retries.",

  VERIFY_THE_FOLLOWING_INFO: "Please check the following information:",
  INVALID_IP: "\n- The entered IP is invalid",
  INVALID_SUBMASK: "\n- The entered mask is invalid",
  INVALID_GATEWAY: "\n- The entered gateway is invalid",
  INVALID_DNS: "\n- The entered DNS is invalid",
  LOOPBACK_IP: "\n- The loopback IP (127.0.0.1) cannot be used as the TS Scope PA IP",
  LOOPBACK_IP_NTP: "\n- The loopback IP (127.0.0.1) cannot be used as the NTP server IP",
  TAG_TOO_LONG: "The tag size cannot exceed 30 characters",
  SELECT_TIMEZONE: "\n- You must select a time zone to configure the NTP server",
  SAME_SUBNET_IP_1: "\n- The office interface IP address cannot be on the same subnet as the ETHERNET interface.",
  SAME_SUBNET_IP_2: "\n- The ETHERNET interface IP address cannot be on the same subnet as the office interface.",
  SUBNET_OVERLAP_WLAN: "\n- TS Scope PA detected overlapping addresses between the ETHERNET interface subnet and the WLAN subnet. For this reason, the WLAN cannot be configured with the chosen IP address and mask.",
  SUBNET_OVERLAP_ETHERNET_WLAN: "\n- TS Scope PA detected overlapping addresses between the ETHERNET interface subnet and the WLAN subnet. For this reason, the ETHERNET interface cannot be configured with the chosen IP address and mask.",
  ZERO_IP_MSG: "\n- IP 0.0.0.0 cannot be used as the TS Scope PA IP",
  ZERO_IP_MASK_MSG: "\n- IP 0.0.0.0 cannot be used as the network mask",
  BROADCAST_IP_MSG: "\n- The network broadcast IP cannot be used as the TS Scope PA IP",
  NETWORK_IP_MSG: "\n- The network IP cannot be used as the TS Scope PA IP",
  BROADCAST_GATEWAY_MSG: "\n- The network broadcast IP cannot be used as the gateway IP",
  NETWORK_GATEWAY_MSG: "\n- The network IP cannot be used as the gateway IP",

  CHOOSE_A_CHANNEL: "To save the tag, you must select a channel",

  ALTER_USERNAME: "CHANGE USER",
  ALTER_PASSWORD: "CHANGE PASSWORD",

  SYSTEM: "System",
  RESTART: "Restart",
  CONFIRM_RESTART_SYSTEM: "Are you sure you want to restart the system?",
  RESTART_SYSTEM_FAILURE: "An error occurred while trying to restart the system.",
  RESTART_SYSTEM_SUCCESS: "Restart request sent successfully. Wait about 3 minutes for the system to restart completely.",

  SELECT_FILE: "Please select a file to be sent",
  SELECT_GSD_FLIE: "Please select at least one GSD file to be sent",
  SENDING_GSD_FILES: "Sending GSD files",

  DO_NOT_CLOSE_THIS_TAB: "Keep this tab open to follow the update.",
  UPDATING_MONITOR_FILES: "Updating files on TS Scope PA. Please wait.",
  MONITOR_FILES_UPDATED_SUCCESSFULLY: "Files updated, preparing to restart TS Scope PA.",
  RESTARTING_MONITOR_WAIT: "Restarting TS Scope PA, please wait a few minutes.",
  UPDATE_SUCCESS: "The update was completed successfully!",
  UPDATE_ERROR_STRING: "The following error occurred while updating TS Scope PA: ",

  CHANGE_AT_LEAST_ONE_OF_THE_FIELDS: "Modify at least one of the fields to update the interface settings.",
  REMEMBER_TO_UPDATE_BROWSER_ADDRESS_TO: "\nRemember to update the browser address to: ",
  UPDATE_INTERFACE_CONFIG_SUCCESS: "The interface settings were updated successfully!",

  THE_FOLLOWING_FILES_COULD_NOT_BE_SENT: "An error occurred while sending the following GSD files: ",
  THE_FOLLOWING_FILES_COULD_NOT_BE_REMOVED: "An error occurred while removing the following GSD files: ",

  ALTER: "Change",
  CHANNELS: "Channels",
  CHANNELS_TAGS: "Channel tags",
  DEVICES_TAGS: "Device tags",

  TAG_AND_NOTE_FROM_CHANNEL: "The tag of channel ",
  WAS_SUCCESSFULLY_ALTERED: " was changed successfully!",
  ALTER_TAG_ERROR: "An error occurred while changing the tag of channel ",
  ALTER_TAG_ERROR_REASON: ".\nReason: ",
  ERROR_REASON: ".\nReason: ",

  NOTE: "Note",
  MONITOR_IP: "TS Scope PA IP",

  IS_IN_SEGMENT_QUESTION: "Belongs to the Segment?",

  IN_SEGMENT_DEVICES: "Segment devices",
  UPDATING_DATA: "Updating information, please wait",
  IN_SEGMENT_FORM_INPUT_PLACEHOLDER: "Filter devices by address",

  IS_IN_SEGMENT_POPUP_DESCRIPTION_1: "List of devices belonging to the same segment as this TS Scope PA channel.",
  IS_IN_SEGMENT_POPUP_DESCRIPTION_2: "If the device is unchecked in this list, it means that it does not belong to the same segment as this TS Scope PA channel.",
  IS_IN_SEGMENT_POPUP_DESCRIPTION_3: "If it does not belong to the same segment, the waveform seen on the oscilloscope may not match the device's actual waveform.",

  CONFIRM_ALTER_SEGMENT_DEVICES: "Are you sure you want to make changes to the list of devices belonging to the segment?",

  ALTER_IS_IN_SEGMENT_LIST_FAILURE: "An error occurred while changing the segment device list.",
  ALTER_IS_IN_SEGMENT_LIST_SUCCESS: "The segment device list was changed successfully!",

  ETHERNET: "Ethernet",
  ETHERNET_POPUP_1: "Ethernet interface configuration field.",
  ETHERNET_POPUP_2: "Used for supervision and web access to TS Scope PA data.",

  WLAN: "WLAN",
  WLAN_POPUP_1: "Wireless interface configuration field, when an adapter is available.",
  WLAN_POPUP_2: "Used for supervision and web access to TS Scope PA data.",

  SEND_NTP_CONFIG_WAITING: "Sending NTP server settings.",

  NTP_SERVER: "NTP Server",

  TURN_NTP_SERVER_ON: "Turn NTP server on",
  TURN_NTP_SERVER_OFF: "Turn NTP server off",
  TURN_NTP_SERVER_ON_QUESTION: "Are you sure you want to turn on the NTP server? TS Scope PA will need to be restarted for this.",
  TURN_NTP_SERVER_OFF_QUESTION: "Are you sure you want to turn off the NTP server? TS Scope PA will need to be restarted for this.",

  PROCESSING_NTP_INIT: "Starting NTP server information processing.",
  PROCESSING_NTP_INFO: "Processing NTP server information.",
  PROCESSED_NTP_INFO: "NTP server information processed.",
  PROCESSING_NTP_ERROR: "An error occurred while sending the information to the NTP server. Check whether the server IP address is correct. If it is, also check whether the NTP service is on and try again.",

  NTP_INFO_TURNED_ON_SUCCESS: "The NTP server was turned on successfully.",
  NTP_INFO_TURNED_ON_FAILURE: "An error occurred while turning on the NTP server.",
  NTP_INFO_FAILURE: "Failed to synchronize with the server. If the error persists, contact the NTP server administrator.",
  TURN_ON_DATE: "\nThe server time was updated to: ",

  MONITOR_WILL_BE_RESTARTED: "\nTS Scope PA will be restarted now,",
  MONITOR_RESTART_SUCCESS: "TS Scope PA was restarted successfully.",
  MONITOR_RESTART_FAILURE: "An error occurred while restarting TS Scope PA.",

  NTP_INFO_TURNED_OFF_SUCCESS: "The NTP server was turned off successfully.",
  NTP_INFO_TURNED_OFF_FAILURE: "An error occurred while turning off the NTP server.",
  TURN_OFF_DATE: "\nShutdown time: ",

  TAG_CONFIG: "Segment tag",

  TAG_WAS_CHANGED_SUCCESSFULLY: "The TS Scope PA tag was changed successfully.",
  TAG_CHANGE_FAILURE: "An error occurred while changing the TS Scope PA tag.",

  TS_EXPERT_CONFIG_POPUP: "Allows enabling/disabling the non-conformities to be reported by the tool.",
  DNS: "DNS",

  REASON_PA: "Reason: ",
  // ---------------------------- Edit Tags page related ----------------------------
  ADD_ALTER_TAGS: "Add/Change Tags",
  CHOOSE_DEVICE: "Choose a device",
  NEW_TAG: "New TAG",
  REMOVE_ALL_TAGS: "Remove all Tags",
  CONFIRM_REMOVE_ALL_TAGS: "Are you sure you want to remove the tags from all devices?",
  CHANGE_TAG_SUCCESS: "The tag was changed successfully.",
  CHANGE_TAG_FAILURE: "An error occurred while changing the tag",
  REMOVE_TAG_SUCCESS: "The tags were removed successfully.",
  REMOVE_TAG_FAILURE: "An error occurred while removing the tags",
  IMPORT_TAGS_SUCCESS: "The tags were imported successfully",
  IMPORT_TAGS_SUCCESS_1: "The tags of channel ",
  IMPORT_TAGS_SUCCESS_2: " were imported successfully",

  IMPORT_TAGS_FAILURE: "An error occurred while importing the tags: ",
  PLEASE_SELECT_TAG_FILE: "Please select a tag file.",
  IMPORT_TAGS: "Import tags",
  EXPORT_TAGS: "Export tags",

  CHOOSE_A_CHANNEL_FIRST: "You must select a channel first",
  CHOOSE_A_DEVICE_FIRST: "You must select a device first",

  THE_IP_DP: "The IP: ",
  TOOK_TOO_LONG_TO_RESPOND: " took too long to respond.",

  TAGS_CONFIG: "TAG SETTINGS",

  // ---------------------------- WLAN Config ----------------------------
  WLAN_STATUS: "WLAN Adapter",
  WLAN_CONFIG: "WLAN Settings",
  CONNECTION_STATUS: "Connection status",

  WLAN_ADAPTER_ON: "On",
  WLAN_ADAPTER_OFF: "Off",

  IP_PLACEHODLER: "192.168.2.210",
  SSID: "SSID",
  SIGNAL_STRENGTH: "Signal strength",
  FREQUENCY: "Frequency",
  QUALITY: "Quality",

  SSID_PLACEHOLDER: "SSID",
  MAC_PLACEHOLDER: "A0:8C:FD:19:DB:02",
  SIGNAL_STRENGTH_PLACEHOLDER: "90 dBm",
  FREQUENCY_PLACEHOLDER: "2.4GHz",
  CHANNEL_PLACEHOLDER: "1",
  QUALITY_PLACEHOLDER: "Quality",

  TURNING_WLAN_OFF_WAITING: "Turning off the WLAN adapter, please wait.",
  TURNING_WLAN_ON_WAITING: "Turning on the WLAN adapter, please wait.",

  NETWORK: "Network",
  NETWORK_NAME_1: "Network name",
  SUBMASK: "Mask",
  PASSWORD: "Password",

  ALTER_SCOPE_WLAN_CONFIG: "Are you sure you want to change the TS Scope PA WLAN settings?",

  CONNECTED: "Connected",
  DISCONNECTED: "Disconnected",

  WLAN_STATUS_POPUP_1: "Indicates the state of the TS Scope PA WLAN adapter.",
  WLAN_STATUS_POPUP_2: "If it is off, the WLAN settings cannot be changed.",

  CONNECTION_STATUS_POPUP_1: "Indicates whether TS Scope PA is connected to the configured WLAN network.",

  WLAN_CONFIG_POPUP_1: "Settings cannot be changed while the adapter is turned off.",
  WLAN_CONFIG_POPUP_2: "It is highly recommended that WLAN settings be changed only when accessing TS Scope PA through the wired network.",
  WLAN_CONFIG_POPUP_3: "When changing the IP/mask, if the fields appear blank after the update, this is a strong indication that:",
  WLAN_CONFIG_POPUP_4: "Another device already exists on the network with the same IP;",
  WLAN_CONFIG_POPUP_5: "The network mask is too restrictive and does not support the IP that was provided.",

  WLAN_ADAPTER_NOT_FOUND_1: "TS Scope PA could not find the WLAN adapter:\n",
  WLAN_ADAPTER_NOT_FOUND_2: "  • Check whether the adapter is disconnected or has poor contact;\n",
  WLAN_ADAPTER_NOT_FOUND_3: "  • If the adapter is not disconnected and does not have poor contact, try replacing it;\n",
  WLAN_ADAPTER_NOT_FOUND_4: "  • If none of the previous options solves the problem, contact Toledo & Souza.",

  CHANGE_AT_LEAST_ONE_OF_THE_FIELDS_WLAN: "Modify at least one of the fields to update the WLAN settings.",
  UPDATE_WLAN_CONFIG_SUCCESS: "The WLAN settings were updated successfully!",
  SEND_WLAN_CONFIG_WAITING: "Sending the settings, please wait. This may take about one minute.",
  LOADING_WAITING: "Loading information, please wait.",
  WLAN_INFO: "WLAN information",
  MAC: "MAC",

  UPDATE_WLAN_CONFIG_ERROR: "Could not connect to the WLAN network. If the problem persists, try restarting TS Scope PA or the WLAN router.",

  HOSTNAME_POPUP_1: "A hostname must be between 2 and 64 characters to be valid.",
  HOSTNAME_POPUP_2: "In addition, it may contain only letters, numbers, periods, and hyphens, and must start and end only with letters and numbers.",
  
  INVALID_HOSTNAME_1: "The hostname must be between 2 and 64 characters.",
  INVALID_HOSTNAME_2: "The hostname must contain only letters, numbers, periods, and hyphens, and must start and end only with letters and numbers.",

  HOSTNAME_CONFIG_SUCCESS: "The hostname was configured successfully.",
  HOSTNAME_CONFIG_ERROR: "An error occurred while configuring the hostname",
  MODE: "Mode",
  HIDDEN_SSID: "Hidden SSID",
  OPTIONAL: " (Optional)",

  FIXED_IP: "Fixed IP",

  ALTER_MONITOR_WLAN_CONFIG: "Are you sure you want to change the TS Scope PA WLAN settings?",

  // ---------------------------- TS EXPERT CONFIG ---------------------------- 
  SENDING_TS_EXPERT_CONFIG_WAITING: "Updating TS Expert settings, please wait a moment.",
  TS_EXPERT_CONFIG_SAVED_SUCCESSFULLY: "TS Expert settings were saved successfully.",
  TS_EXPERT_CONFIG_SAVE_ERROR: "An error occurred while saving TS Expert settings.",

  TS_EXPERT_CONFIGURATION: "TS Expert Settings",

  PA_TERMINATOR_OFF_LIST_HEADER: "Missing terminator",
  PA_TERMINATOR_OFF_LIST_CONTENT: "When this option is enabled, TS Expert will indicate to the user a possible missing termination condition on the network.",

  PA_CAPACITIVE_EFFECT_LIST_HEADER: "Jitter out of specification",
  PA_CAPACITIVE_EFFECT_LIST_CONTENT: "When this option is enabled, TS Expert will indicate to the user a possible out-of-specification jitter condition.",

  PA_HIGH_RESISTANCE_LIST_HEADER: "Attenuated signal",
  PA_HIGH_RESISTANCE_LIST_CONTENT: "When this option is enabled, TS Expert will indicate to the user a possible attenuated signal condition on the PA bus.",

  PA_INVERTED_POLARITY_LIST_HEADER: "Inverted polarity",
  PA_INVERTED_POLARITY_LIST_CONTENT: "When this option is enabled, TS Expert will indicate to the user a possible inverted polarity condition.",

  PA_NOISE_LIST_HEADER: "Noise",
  PA_NOISE_LIST_CONTENT: "When this option is enabled, TS Expert will indicate to the user a possible noise condition on the PA network.",

  PA_DADOS_LIST_HEADER: "Variable status",
  PA_DADOS_LIST_CONTENT: "When this option is enabled, TS Expert will indicate to the user a possible anomaly condition in the variable status.",

  PA_UNBALANCE_LIST_HEADER: "Unbalance",
  PA_UNBALANCE_LIST_CONTENT: "When this option is enabled, TS Expert will indicate to the user a possible unbalance condition.",

  PA_GENERAL_SIGNAL_LOSS_HEADER: "General PA signal loss",

  // ---------------------------- TS EXPERT ----------------------------
  SCOPE_TAG: "Scope tag:",
  CHANNEL_TAG_2: "Channel tag:",
  TS_EXPERT_REPORT_EXPORT_NAME: "Actions list - TS Expert - TS Scope PA",

  TS_EXPERT_POPUP_1: "This tab displays TS Expert information.",
  TS_EXPERT_POPUP_2: "This tool is an expert system developed to optimize and accelerate the analysis of the main divergences detected by TS Scope PA in PA networks.",
  TS_EXPERT_POPUP_3: "In an automated way, maintenance, engineering, and related teams can obtain an actions list with different events, their possible causes, solution suggestions, and the devices on which they were detected.",
  TS_EXPERT_POPUP_4: "Using TS Expert does not eliminate the need for human analysis, nor does it replace the ability to correlate data and interpret results.",

  TS_EXPERT: "TS Expert",
  DETECTED_ON: "Detected on: ",
  CHECK_YOUR_NETWORK: "Please check your network.",

  EXPORT_ACTIONS_LIST: "Export actions list",
  GENERATING_ACTIONS_LIST_WAITING: "Generating actions list PDF, please wait.",
  ACTIONS_LIST_NAME: "Actions list - TS Scope PA - Channel",
  GENERATING_ACTIONS_LIST_WAITING_2: "Finishing...",
  SAVE_ACTIONS_LIST: "Save actions list",
  GENERATING_ACTIONS_LIST_SUCCESS: "PDF generated successfully. To save it, click save actions list.",

  EVENTS_LIST: "List of events",
  ACTIONS: "Actions",

  NO_PROBLEM_DETECTED: "TS Expert did not detect any event on the network.",
  NO_EVENTS_TO_BE_ANALYZED: "There are no events to be analyzed.",

  NO_EVENT_SELECTED: "No event selected",
  CHOOSE_AN_EVENT: "Select an event to view suggested actions.",

  DETAILING: "Details",

  CHECKED: "Clear",
  BATCH_CHECK: "Clear all",

  PROBLEM_CHECKED: "The event was cleared successfully",
  PROBLEM_CHECK_ERROR: "An error occurred while clearing the event.",

  QUANTITY_DP: "Quantity: ",
  INCREMENTS: "Increments",

  PORT_IS_STILL_INACTIVE: "The port is still inactive",
  MARK_PROBLEM_AS_SOLVED: "Are you sure you want to mark the event as cleared?",

  LAST_UPDATED: "Last updated on: ",
  THIS_COMPUTER_TIME: " (This computer's time)",

  DEVICE: "Device",
  DEVICES: "Devices",
  UNKNOWN: "Unknown",

  ALL_EVENTS_WERE_CHECKED: "All events were checked successfully.",
  CHECK_EVENT_OBS: "\nIt is important to note that some data may take up to 15 minutes to be updated. Therefore, it is suggested to wait some time before clearing this list by clicking check.\n",

  UNABLE_TO_CHECK_TERMINATION_OFF_EVENTS: "Could not check the events for the following devices because TS Scope PA continues to detect a missing termination condition:\n",
  UNABLE_TO_CHECK_CAPACITIVE_EFFECT_EVENTS: "Could not check the events for the following devices because TS Scope PA continues to detect out-of-specification jitter:\n",
  UNABLE_TO_CHECK_NOISE_EVENTS: "Could not check the events for the following devices because TS Scope continues to detect a noise condition (amplitude greater than 30% of the slave signal amplitude):\n",
  UNABLE_TO_CHECK_INVERTED_POLARITY_EVENTS: "Could not check the events for the following devices because TS Scope PA continues to detect a polarity inversion condition:\n",
  UNABLE_TO_CHECK_HIGH_RESISTANCE_EVENTS: "Could not check the events for the following devices because TS Scope PA continues to detect attenuated signal:\n",
  UNABLE_TO_CHECK_DADOS_EVENTS: "Could not check the events for the following devices because TS Scope PA continues to detect an anomaly in the variable status:\n",
  UNABLE_TO_CHECK_UNBALANCE_EVENTS: "Could not check the events for the following devices because TS Scope PA continues to detect an unbalance:\n",

  PAGE: "Page",

  // ---------------------------- FF TERMINATOR OFF ----------------------------
  PA_TERMINATION_OFF_SUGGESTION_1: "When there is a missing terminator, it is suggested to:",
  PA_TERMINATION_OFF_SUGGESTION_2: "Visually check whether the terminators at both ends of the segment are connected, either at the coupler and the last junction box, or at the coupler and the farthest slave.",
  PA_TERMINATION_OFF_SUGGESTION_3: "It is recommended to wait for a shutdown or schedule with production before turning on/installing the terminator.",

  // ---------------------------- CAPACITIVE EFFECT ----------------------------
  CAPACITIVE_EFFECT_SUGGESTION_1: "When out-of-specification jitter is detected, it is suggested to:",
  CAPACITIVE_EFFECT_SUGGESTION_2: "Check the following items:",
  CAPACITIVE_EFFECT_SUGGESTION_3: "Equipment insulation;",
  CAPACITIVE_EFFECT_SUGGESTION_4: "Moisture on the bus;",
  CAPACITIVE_EFFECT_SUGGESTION_5: "Problems in the slave electronics;",
  CAPACITIVE_EFFECT_SUGGESTION_6: "Oxidation on slave connections;",
  CAPACITIVE_EFFECT_SUGGESTION_7: "Oxidation on junction box / barrier connections;",
  CAPACITIVE_EFFECT_SUGGESTION_8: "Long cable.",

  // ---------------------------- HIGH RESISTANCE ----------------------------
  PA_HIGH_RESISTANCE_SUGGESTION_1: "When there is an attenuated signal on the bus, it is suggested to:",
  PA_HIGH_RESISTANCE_SUGGESTION_2: "Check whether any equipment in the segment has an internal terminator turned on, such as a junction box. If no equipment has an internal terminator turned on, check the slave electronics by isolating them individually from the bus.",
  PA_HIGH_RESISTANCE_SUGGESTION_3: "High-resistance points should also be checked, such as loose terminals and crushed cables.",

  // ---------------------------- INVERTED POLARITY ----------------------------
  PA_INVERTED_POLARITY_SUGGESTION_1: "When inverted polarity is detected, it is suggested to:",
  PA_INVERTED_POLARITY_SUGGESTION_2: "Not all couplers accept inverted polarity, so this may cause problems on the network.",
  PA_INVERTED_POLARITY_SUGGESTION_3: "The installation should be checked. If it is correct, contact the slave manufacturer.",

  // ---------------------------- NOISE ----------------------------
  PA_NOISE_SUGGESTION_1: "When there is noise or low insulation (ground leakage), it is suggested to:",
  PA_NOISE_SUGGESTION_2: "This is one of the most complex problems in industrial networks. Below are 4 basic tips that should help solve this problem:",
  PA_NOISE_SUGGESTION_3: "Check the insulation of the slave interfaces. A simple way is to disconnect them from the network one by one and check whether the problem persists;",
  PA_NOISE_SUGGESTION_4: "To attenuate noise, it is necessary to check whether all slaves on the network are properly grounded;",
  PA_NOISE_SUGGESTION_5: "It is necessary to check the equipotential bonding of the grounding system. A simple way is to check whether there is leakage current in the PA cables. A value below 100 mA is expected;",
  PA_NOISE_SUGGESTION_6: "If the current is greater than 100 mA, one tip is to isolate the shield at the slave while always keeping the slave grounded.",
  PA_NOISE_SUGGESTION_7: "If the problem persists after these basic tips, we recommend contacting a PA network specialist.",

  // ---------------------------- DATA ----------------------------
  PA_DADOS_SUGGESTION_1: "Variable status indicating an anomaly. It is suggested to check:",
  PA_DADOS_SUGGESTION_2: "The variable status and correct it;",
  PA_DADOS_SUGGESTION_3: "The operating condition of the instrument.",
  PA_DADOS_SUGGESTION_4: "• Check and correct the variable status;",
  PA_DADOS_SUGGESTION_5: "• Check the operating condition of the instrument.",
  
  // ------------------------ UNBALANCE ---------------------------
  PA_UNBALANCE_SUGGESTION_1: "When there is unbalance, it is suggested to:",
  
  PA_UNBALANCE_SUGGESTION_2: "Check the influence of devices on the bus, because defects that cause changes in the original electrical characteristics of the electronic circuits and electronic insulation problems may be reflected as signal unbalance. Another cause of this problem may be leakage to ground caused by a damaged cable.",

  // ---------------------------- EXPERT REPORT ----------------------------
  TS_EXPERT_DP: "TS Expert:",
  ACTIONS_LIST: "Actions list",

  MONITORING_INIT: "- Monitoring start: ",
  REPORT_GENERATION: "- Report generation time:",
  CHANNEL_TAG: "- Channel tag: ",

  PA_TERMINATION_OFF_PAGE_TITLE: ". - Missing terminator",
  PA_CAPACITIVE_EFFECT_PAGE_TITLE: ". - Jitter out of specification",
  PA_HIGH_RESISTANCE_PAGE_TITLE: ". - Attenuated Signal",
  PA_INVERTED_POLARITY_PAGE_TITLE: ". - Inverted polarity",
  PA_NOISE_PAGE_TITLE: ". - Noise or low insulation (ground leakage)",
  PA_DADOS_PAGE_TITLE: ". - Variable status",
  PA_UNBALANCE_PAGE_TITLE: ". - Unbalance",

  SUGGESTION: "Suggested action",
  EVIDENCE: "Evidence",
  EVIDENCE_SINGULAR: "Evidence",
  EVIDENCE_DESCRIPTION: "Evidence capture of the non-conformity reported by TS Expert:",
  NO_EVIDENCE_DESCRIPTION_1: "In cases of no signal, the evidence capture of the non-conformity is not shown, since there is no PA signal to be analyzed.",
  NO_EVIDENCE_DESCRIPTION_2: "For this reason, below is a table containing all devices whose signals were not detected, their respective channels, and the time when the problem was detected.",

  PA_TERMINATION_OFF_PAGE_DESCRIPTION: "TS Expert is indicating a possible missing terminator on the network.",
  PA_CAPACITIVE_EFFECT_PAGE_DESCRIPTION: "TS Expert is indicating a possible presence of capacitive effect.",
  PA_HIGH_RESISTANCE_PAGE_DESCRIPTION: "TS Expert is indicating a possible excess of terminators or high resistance on the PA bus.",
  PA_INVERTED_POLARITY_PAGE_DESCRIPTION: "TS Expert is indicating a possible inverted polarity condition.",
  PA_NOISE_PAGE_DESCRIPTION: "TS Expert is indicating a possible noise condition on the PROFIBUS PA network.",
  PA_DADOS_PAGE_DESCRIPTION: "TS Expert is indicating a possible anomaly condition in the variable status.",
  PA_UNBALANCE_PAGE_DESCRIPTION: "TS Expert is indicating a possible unbalance condition.",
  // ---------------------------- ACTIVE CHANNELS ----------------------------
  ACTIVE_CHANNELS: "Active channels",
  ACTIVE_CHANNELS_POPUP_1: "Allows configuring which TS Scope PA channels are currently active (which channels will be used).",
  ACTIVE_CHANNELS_POPUP_2: "It is recommended to disable all channels that are not currently being used.",
  SAVING_ACTIVE_CHANNELS: "Saving active channels, please wait.",
  SEND_ACTIVE_CHANNELS_SUCCESS: "The active channels were saved successfully!\nAfter pressing OK, you will be redirected to the TS Scope PA home page.",
  SEND_ACTIVE_CHANNELS_ERROR: "An error occurred while saving the active channels",
  CANT_TURN_ALL_CHANNELS_OFF: "It is not possible to deactivate all TS Scope PA channels at the same time.\n\nAt least one channel must remain active.",

  // ---------------------------- PA NETWORK VERSION ----------------------------
  PA_NETWORK_VERSION: "PROFIBUS PA network version",
  PA_NETWORK_VERSION_2: "Version 2.0",
  PA_NETWORK_VERSION_2_1: "Version 2.1",
  PA_NETWORK_VERSION_POPUP_1: "Allows configuring the version of the PROFIBUS PA network monitored by each TS Scope PA channel.",
  PA_NETWORK_VERSION_POPUP_2: "PA networks that use protocol version 2.0 support up to 32 devices per network, addressed from 1 to 32.",
  PA_NETWORK_VERSION_POPUP_3: "PA networks that use protocol version 2.1 or higher support up to 64 devices, addressed from 1A to 32A and from 1B to 32B.",
  DISABLED_CHANNELS_POPUP_1: "Some channels may appear disabled on this screen, and the PROFIBUS PA network version cannot be modified.",
  DISABLED_CHANNELS_POPUP_2: "This occurs when they are turned off. To modify the network version of the channel, go to the channel settings screen and enable them.",
  SEND_PA_TYPE_SUCCESS_1: "The network version of 'Channel ",
  SEND_PA_TYPE_SUCCESS_2: "' was saved successfully!",
  SEND_PA_TYPE_ERROR: "An error occurred while saving the network version of 'Channel ",

  PA_TERMINATION_OFF_DOTS: ".......................................................................................................................",
  PA_CAPACITIVE_EFFECT_DOTS: ".............................................................................................................",
  PA_HIGH_RESISTANCE_DOTS: ".........................................................................................................................",
  PA_INVERTED_POLARITY_DOTS: "............................................................................................................................",
  PA_NOISE_DOTS: "..............................................................................................................................................",
  PA_DADOS_DOTS: "..............................................................................................................................",
  PA_UNBALANCE_DOTS: "......................................................................................................................................",

  PA_DISCLAIMER_EXPERT_DOTS: "....................................................................................................................................",

  // ---------------------------- LOADING ----------------------------
  INITIALIZING_SCOPE_DP: "Initializing TS Scope PA, please wait."

});